import { render, staticRenderFns } from "./contenidoModalReinscribirBA.vue?vue&type=template&id=285ad7ce&"
import script from "./contenidoModalReinscribirBA.vue?vue&type=script&lang=js&"
export * from "./contenidoModalReinscribirBA.vue?vue&type=script&lang=js&"
import style0 from "./contenidoModalReinscribirBA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports